import { LONGEVITY_LOGIN_REQUEST } from "./constant";

export const longevitySignIn = (data) => {
  return {
    type: LONGEVITY_LOGIN_REQUEST,
    data,
  };
};
